import React from 'react';
import './AMR.css';
import FMSimage from '../Assets/amr111.jpg'; // First image (full size)
import FMSimage2 from '../Assets/Autometic-meter-reading.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/amr3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/amr4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/street5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">RETROFIT AMR SOLUTION</h1>
                    <p className="FMS-description">
                    The Retrofit Automated Meter Reading (AMR) Solution from Vajra IoT is a state-of-the-art technology designed to modernize and automate the process of meter reading. This solution improves accuracy, minimizes manual errors, reduces operational costs, and provides real-time insights, ensuring efficient utility management for urban and industrial applications.</p>                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Fuel Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <li><strong>Automatic Meter Reading:</strong> Enables seamless and automated collection of utility consumption data, eliminating manual meter reading efforts and errors.</li>
                        <li><strong>Real-Time Data Insights:</strong> Provides real-time monitoring of energy usage, ensuring timely and informed decision-making.</li>
                        <li><strong>GPS Synchronization:</strong> Features an integrated GPS receiver for precise time-stamping and location tracking, ensuring accurate and reliable data logging.





</li>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <li><strong>Centralized Data Collection:</strong> A unified platform gathers consumption data from all meters in designated areas for streamlined monitoring.</li>
                        <li><strong>Automated Data Transmission:</strong> Meters transmit readings automatically at scheduled intervals, eliminating manual collection.</li>
                        <li><strong>Energy Usage Analysis:</strong> Tracks and logs consumption patterns to provide detailed insights for optimizing resource management.</li>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Retrofit AMR SOlution</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Energy Efficiency:</strong> Optimizes power usage by providing accurate, real-time consumption data.</li>
                            <li><strong>Reduced Losses:</strong>Minimizes energy loss and theft through automated monitoring and secure data transmission.</li>
                            <li><strong>Cost Savings:</strong>Enables informed decision-making to reduce operational costs and improve resource allocation.</li>
                            <li><strong>Ease of Use:</strong>Offers a user-friendly interface for centralized monitoring and efficient management.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our FMS */}
            {/* New Section: Industries Using Our FMS */}
<div className="FMS-bottom-heading">
    <h2 className="FMS-bottom-text">Industries Using Our System</h2>
</div>

<div className="FMS-content-container reverse-order-last">
    {/* Left side: Image for Industries */}
    <div className="FMS-image-container">
        <img src={FMSimage5} alt="Industries Using FMS" className="FMS-image smaller-size" />
    </div>

    {/* Right side: Text Content */}
    <div className="FMS-text">
        <p className="FMS-description">
        Our Retrofit AMR Solution is trusted by various industries to streamline energy monitoring and improve operational efficiency. These sectors depend on our solution for its accuracy, reliability, and cost-effectiveness:
        <ul>
                <li>Utilities & Energy Providers</li>
                <li>Industrial Manufacturing Plants</li>
                <li>Residential Communities & Apartments</li>
                <li>Commercial Buildings & Complexes</li>
                <li>Agricultural Farms</li>
            </ul>
        </p>
    </div>
</div>

        </div>
    );
};

export default FMS;
